import {Component, Prop, Vue} from 'vue-property-decorator';
import Event from '../../utils/Event';

const template = `
<div class="form__file" :class="{'form__file--error': hasError}">
  <div class="form__label">{{ label }}</div>
  <div class="form__file-i">
    <div class="form__file-t">
      <span v-if="fileName">{{ fileName }}</span>
      <span v-else class="form__label">{{ label }}</span>
    </div>
    <div class="form__file-c" @click="clearFile" v-show="fileName"><i class="img-close"></i></div>
    <div class="form__file-b">
      <div class="form__file-btn btn btn--small btn--grey">Обзор</div>
      <input type="file" class="form-control" :accept="mimes" @change="setFile($event.target)">
    </div>
  </div>
</div>
`;

@Component({
  template: template,
})
export default class FormFile extends Vue {
  @Prop({default: 'file'}) inputKey!: string;
  @Prop({default: ''}) label!: string;
  @Prop({default: ''}) mimes!: string;
  @Prop({default: false}) hasError!: boolean;

  files: any | null = null;
  fileName = '';

  async setFile(target: HTMLInputElement) {
    if (!target.files || !target.files[0]) {
      return;
    }

    this.$emit('update:file', target.files[0]);
    this.fileName = target.files[0].name;
  }

  clearFile() {
    this.$emit('update:file', null);
    this.fileName = '';
  }
}
